// import json_parse from './json_parse'

//const coinApi = 'https://www.bitfeel.cn/'

const serverApi = process.env.NODE_ENV == 'production' ? "/tokenbox" : "/server"
// 请求函数
export function myFetch(postdata, url = '', method) {
  // postdata = JSON.stringify(postdata);
  var params = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': "*",
    },
    redirect: 'follow',
    method: method || 'POST',
  }
  if (method === 'POST'||method === 'PUT' || !method) {
    params.body = postdata
  }
  if (method === 'DELETE' || !method) {
    params.body = postdata
  }
  if (method === 'GET' && postdata) {
    let queryArr = []
    // 过滤值为空字符串，null，undefined的参数
    Object.keys(postdata).filter(q => postdata[q] === 0 || postdata[q]).forEach(q => queryArr.push(`${q}=${postdata[q]}`))
    // console.log('queryArr', queryArr);
    url = `${url}?${queryArr.join('&')}`
    postdata = false
  }
  // console.log(params)
  return fetch(url, params)
    .then((res) => {
      var response = res
      if (response.status >= 200 && response.status < 300) {
        return response.json()
      } else {
        var error = new Error(response.statusText)
        error.response = response
        throw error
      }
    }).catch((err) => {
    })
}

/* 接口部分 */
// 总类列表
export function compilerContract(params) {
  let url = serverApi + '/compilation'
  return myFetch(params, url, 'POST')
}
export function requestContractGas(params) {
  let url = serverApi + '/gas/chain'
  return myFetch(params, url, 'GET')
}
export function saveContractRecord(params) {
  let url = serverApi + '/save'
  return myFetch(params, url, 'POST')
}
export function updateContractRecord(params) {
  let url = serverApi + '/contract/update'
  return myFetch(params, url, 'PUT')
}
export function consoleQuery(params) {
  let url = serverApi + '/contract/all'
  return myFetch(params, url, 'GET')
}
export function consoleDelete(params) {
  let url = serverApi + '/contract/delete'
  return myFetch(params, url, 'DELETE')
}
export function consoleDetail(params) {
  let url = serverApi + '/contract/code'
  return myFetch(params, url, 'GET')
}
export function contractVerify(params) {
  let url = serverApi + '/verify'
  return myFetch(params, url, 'POST')
}